import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

export default function NotFoundPage() {
    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 relative overflow-hidden">
            {/* Background elements */}
            <div className="absolute inset-0 bg-hero-glow pointer-events-none opacity-50" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-nocturne-purple/5 rounded-full blur-[120px] pointer-events-none" />
            
            <div className="max-w-2xl w-full text-center relative z-10">
                <div className="mb-8 relative inline-block">
                    <h1 className="text-[150px] sm:text-[200px] font-black leading-none tracking-tighter text-nocturne-text opacity-5 select-none">
                        404
                    </h1>
                    <div className="absolute inset-0 flex items-center justify-center">
                        <span className="text-4xl sm:text-5xl font-bold text-nocturne-text">
                            Page <span className="gradient-text">Lost</span>
                        </span>
                    </div>
                </div>

                <h2 className="text-2xl sm:text-3xl font-bold text-nocturne-text mb-4">
                    The dimension you seek doesn't exist.
                </h2>
                
                <p className="text-nocturne-muted text-lg mb-12 max-w-md mx-auto leading-relaxed">
                    The requested URL was not found on this server. It might have been moved, deleted, or never existed in the first place.
                </p>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                    <Link to="/" className="btn-primary w-full sm:w-auto px-8 py-4">
                        <Home size={18} />
                        Return Home
                    </Link>
                    <button 
                        onClick={() => window.history.back()} 
                        className="btn-outline w-full sm:w-auto px-8 py-4"
                    >
                        <ArrowLeft size={18} />
                        Go Back
                    </button>
                </div>
            </div>

            {/* Decorative dots */}
            <div className="absolute top-20 left-20 w-2 h-2 bg-nocturne-purple/20 rounded-full animate-pulse" />
            <div className="absolute bottom-20 right-20 w-3 h-3 bg-nocturne-purple/30 rounded-full animate-pulse delay-700" />
            <div className="absolute top-40 right-40 w-1.5 h-1.5 bg-nocturne-purple/10 rounded-full animate-pulse delay-1000" />
        </div>
    );
}
